import { msg } from 'gt-react';

export const EXTRA_AUDIT_FIELD_LABELS = {
  vendor_numbers: msg('Vendor #s', {
    context:
      'label for the specific 5-digit vendor numbers a price change is for',
  }),
  waiting_on_key: msg('Waiting on', {
    context: 'label for what a pricelist case is parked on',
  }),
  follow_up_at: msg('Follow-up date', {
    context: "label for a pricelist case's follow-up date",
  }),
  files_ready_at: msg('Files ready date', {
    context:
      'label for the vendor-stated date a price file will be available to upload',
  }),
  vendor_code: msg('3 letter code / PG', {
    context:
      "label for the export's 3-letter vendor / commodity code on a price change",
  }),
  national_im_comparing_comments: msg(
    'National IM comparing — internal comments',
    {
      context:
        "label for the export's national IM comparing internal comments column",
    },
  ),
  upload_comments: msg('Upload comment — internal comments', {
    context: "label for the export's upload comment internal comments column",
  }),
} as const;

export type ExtraAuditField = keyof typeof EXTRA_AUDIT_FIELD_LABELS;

export function extraAuditFieldLabel(
  field: string,
): (typeof EXTRA_AUDIT_FIELD_LABELS)[ExtraAuditField] | null {
  if (field in EXTRA_AUDIT_FIELD_LABELS) {
    return EXTRA_AUDIT_FIELD_LABELS[field as ExtraAuditField];
  }
  return null;
}
